import { Card } from "@/components/ui/card";
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip, Legend } from "recharts";
import { getTransactionTypeLabel } from "../TransactionTypeUtils";

interface TransactionTypePieChartProps {
  transactions: any[];
}

export const TransactionTypePieChart = ({ transactions }: TransactionTypePieChartProps) => {
  const transactionsByType = transactions.reduce((acc: any, transaction) => {
    const type = transaction.is_fully_paid === false ? "credit_sale" : transaction.transaction_type;
    const label = getTransactionTypeLabel(type);
    acc[label] = (acc[label] || 0) + 1;
    return acc;
  }, {});

  const pieChartData = Object.entries(transactionsByType).map(([name, value]) => ({
    name,
    value,
  }));

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];

  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-4">Répartition par type</h3>
      <div className="h-[300px]">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={pieChartData}
              dataKey="value"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              fill="#8884d8"
            >
              {pieChartData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
};